module.exports = __webpack_public_path__ + "static/media/homepage-edit-schedule.6a25bbd5.webm";